// Central business + content data (source of truth from live site)

export const BUSINESS = {
  name: "Mom's Best Friend Sitters",
  established: "1994",
  phone: "972-476-0500",
  phoneHref: "tel:+19724760500",
  email: "support@mbfagency.com",
  address: "5949 Sherry Ln #1675, Dallas TX 75225",
  minHours: 4,
  nannyUrl: "https://momsbestfriend.com/dallas",
  social: {
    facebook: "https://www.facebook.com/momsbestfrienddallas",
    linkedin: "https://www.linkedin.com/company/moms-best-friend-dallas-and-ft-worth",
    instagram: "https://www.instagram.com/momsbestfrienddallas/",
  },
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1714646793698-f9e961df7059?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  sitterReading: "https://images.unsplash.com/photo-1714646793610-455a4c8a6a6e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  familyMoment: "https://images.unsplash.com/photo-1714646793439-35c2c58596b0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  childPlayful: "https://images.unsplash.com/photo-1627764940620-90393d0e8c34?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  team: "https://images.unsplash.com/photo-1666888735928-68814027acbb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  bedtime: "https://images.unsplash.com/photo-1533222481259-ce20eda1e20b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  dallasSkyline: "https://images.unsplash.com/photo-1621904878414-d4ca4756bd7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dallasSunset: "https://images.unsplash.com/photo-1631662760570-8f7b52d09fdc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SERVICES = [
  {
    id: "babysitting",
    name: "Babysitting",
    tagline: "Date nights, weekends & ongoing care",
    short: "School pick-ups, date nights, weekends, or occasional daytime help for work-from-home parents — whatever your family needs.",
    outcome: "Enjoy your evening knowing your children are with an 11-step screened, CPR-certified caregiver.",
    features: ["Date night & weekend care", "Recurring weekly sitters", "Homework & bedtime routines", "Ages newborn through teen"],
  },
  {
    id: "hotel-care",
    name: "Hotel & Resort Child Care",
    tagline: "For families visiting DFW",
    short: "Enjoy an adult dinner or a break while traveling — our sitters happily engage your kids for the day or evening.",
    outcome: "Attend your event or dinner while your children stay safe and entertained at the hotel.",
    features: ["In-room care at DFW hotels", "Conference & convention care", "Flexible day or evening hours", "Familiar routines away from home"],
  },
  {
    id: "church-care",
    name: "Church & Organization Child Care",
    tagline: "Services, meetings & programs",
    short: "Coverage for weekday Bible studies or Sunday worship — our sitters partner with your staff on all your nursery needs.",
    outcome: "Host your service or event with fully screened caregivers supervising the children's room.",
    features: ["Sunday services & programs", "Board meetings & retreats", "Screened, insured caregivers", "Group ratios that keep kids safe"],
  },
  {
    id: "special-events",
    name: "Special Events & Weddings",
    tagline: "Celebrations, big & small",
    short: "From weddings to annual conferences, qualified sitters perfectly matched to your age range and group size.",
    outcome: "Your guests relax and celebrate while children enjoy their own supervised space.",
    features: ["Weddings & receptions", "Galas & corporate events", "Kids' room setup & activities", "Multiple sitters for groups"],
  },
  {
    id: "overnight-care",
    name: "Overnight Care & Newborn Support",
    tagline: "Rest easy, day or night",
    short: "Steady, comforting overnight care so your children feel safe and supported while you're away.",
    outcome: "Sleep through the night knowing an experienced caregiver is caring for your baby.",
    features: ["Overnight & 24-hour care", "Newborn & infant support", "Feeding & sleep routines", "Post-partum family help"],
  },
  {
    id: "pop-in-pa",
    name: "Pop-In PA",
    tagline: "Personal assistant + light household help",
    short: "A revolutionary Personal Assistant service on an as-needed basis — no contracts, no minimum weekly hours, just help when you need it.",
    outcome: "Reclaim your day with a trusted helper for errands, tidying and family logistics.",
    features: ["Errands & appointments", "Light household organizing", "Meal prep & tidy-up", "Family scheduling support"],
  },
];

export const SERVICE_PRICING = {
  babysitting: "$20/hr sitter pay · +$1/hr per additional child · 4-hour minimum booking.",
  "hotel-care": "$20/hr sitter pay · +$1/hr per additional child · 4-hour minimum. Perfect for in-room or on-property care.",
  "church-care": "Custom staffed rates based on group size and hours — contact us for a tailored quote.",
  "special-events": "Custom event quotes based on guest count, children's ages, and the number of sitters needed.",
  "overnight-care": "Billed hourly with an overnight rate — contact us for a quote tailored to your dates.",
  "pop-in-pa": "$20/hr on an as-needed basis — no contracts and no minimum weekly hours (4-hour booking minimum).",
};

export const STAFF = [
  { name: "Jess Hansel", role: "Families" },
  { name: "Jade Kapler", role: "Sitters" },
  { name: "Shannon Brooks", role: "Special Events" },
];

export const SCREENING_STEPS = [
  { n: 1, title: "Extensive Online Application", desc: "Every applicant completes a thorough application detailing their experience and background." },
  { n: 2, title: "Screening Interview", desc: "A personal interview with our team to assess professionalism, warmth and fit." },
  { n: 3, title: "Reference Checks", desc: "References verified — a minimum of 2 years of professional childcare experience is required." },
  { n: 4, title: "Criminal Background Checks", desc: "Comprehensive multi-state criminal history search." },
  { n: 5, title: "Sex Offender Registry Checks", desc: "National and state sex offender registries cross-checked." },
  { n: 6, title: "SSN & ID Verification", desc: "Social Security number and identity documents confirmed." },
  { n: 7, title: "Motor Vehicle Record Check", desc: "Driving history verified for anyone transporting children." },
  { n: 8, title: "Education Level Verification", desc: "Educational background confirmed and documented." },
  { n: 9, title: "CPR & First Aid Training", desc: "Current CPR and First Aid credentials required and verified." },
  { n: 10, title: "Agency Training", desc: "Sitter professional development and Mom's Best Friend standards training." },
  { n: 11, title: "7-Year Social Media Screening", desc: "A seven-year review of social media for added peace of mind." },
];

export const PROOF = [
  "APNA Accredited",
  '"Best of Texas" Agency',
  "30+ Years Serving DFW",
  "11-Step Screened",
  "100% CPR Certified",
];

export const PRICING = [
  {
    id: "starter",
    name: "Family Starter",
    price: "$39",
    period: "/mo",
    desc: "Ideal for occasional date nights and weekend sitter requests.",
    features: ["3 bookings per month", "Access to screened sitters", "$20/hr sitter pay", "+$1/hr per additional child", "+$15 per extra booking"],
    featured: false,
  },
  {
    id: "pro",
    name: "Family Pro",
    price: "$59",
    period: "/mo",
    desc: "Priority placement, preferred rate locks, and event care access.",
    features: ["5 bookings per month", "Priority sitter placement", "Preferred rate locks", "Special event care access", "$20/hr sitter pay", "+$15 per extra booking"],
    featured: true,
  },
];

export const CITIES = [
  { id: "dallas", name: "Dallas", blurb: "Our home base since 1994 — from Uptown high-rises to Lakewood bungalows, we know Dallas families.", image: "https://images.unsplash.com/photo-1621904878414-d4ca4756bd7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "frisco", name: "Frisco", blurb: "Fast-growing families in Frisco rely on us for reliable weeknight and weekend care.", image: "https://static.prod-images.emergentagent.com/jobs/63540915-4713-49ff-8264-568b5b916c56/images/d346862e2cbc8f776c68ee778667d3deabbe71b4976d3be70955efdc4f248597.jpeg" },
  { id: "southlake", name: "Southlake", blurb: "Premium, discreet care for Southlake families and their busy calendars.", image: "https://static.prod-images.emergentagent.com/jobs/63540915-4713-49ff-8264-568b5b916c56/images/276bc0ad44a9fa3443e0c9e601cc73d83b7b27de073f09aaffef1ae02f80658e.jpeg" },
  { id: "fort-worth", name: "Fort Worth", blurb: "Trusted sitters across Fort Worth, from the Cultural District to Westover Hills.", image: "https://images.unsplash.com/photo-1641084700019-f2db3e6cb66c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "plano", name: "Plano", blurb: "Dependable childcare for Plano's professional and multigenerational households.", image: "https://static.prod-images.emergentagent.com/jobs/63540915-4713-49ff-8264-568b5b916c56/images/5274ddcc770ab3ae177f8512ca3a6f4047eefd5014d5ce675f5b2fb7f4f6c710.jpeg" },
  { id: "colleyville", name: "Colleyville", blurb: "Boutique, screened caregivers serving Colleyville and the mid-cities.", image: "https://static.prod-images.emergentagent.com/jobs/63540915-4713-49ff-8264-568b5b916c56/images/5c06afd7093ba42779a4a0572dfbcbea2f9e11a27258b105f496938caf50bf31.jpeg" },
];

export const TESTIMONIALS = [
  { name: "Sonbol S.", location: "Texas", quote: "We had a great experience with Mom's Best Friend while staying at the Mansion at Turtle Creek for a friend's wedding. The sitter was prompt and kept me updated with texts during the event.", rating: 5 },
  { name: "Marcie L.", location: "Dallas, TX", quote: "All the sitters MBF has sent to our home have been great! One helped me right after I had my third child — she swam with the kids, played games, and let me care for my newborn. I know the owners do their homework hiring the best.", rating: 5 },
  { name: "William P.", location: "Frisco, TX", quote: "I've had multiple successful experiences with Mom's Best Friend. They're accommodating on short notice and reasonably priced. All the sitters have been very kind, attentive, and communicative.", rating: 5 },
  { name: "Kara D.", location: "Southlake, TX", quote: "I've used this service for hotel room babysitting and have LOVED every sitter they sent us. They cared enough to play with and encourage my little one.", rating: 5 },
  { name: "Joel V.", location: "Fort Worth, TX", quote: "I've been using Mom's Best Friend for about 10 years and I've always been impressed — prompt, efficient service and consistently high-quality individuals caring for my children.", rating: 5 },
];

export const FAQS = [
  { q: "What is the minimum booking?", a: "All sitter requests have a 4-hour minimum per booking." },
  { q: "How are your sitters screened?", a: "Every caregiver completes our rigorous 11-step screening: an extensive application, screening interview, reference checks (minimum 2 years professional experience), criminal background and sex offender registry checks, SSN/ID verification, motor vehicle record check, education verification, CPR & First Aid training, agency professional development, and a 7-year social media screening." },
  { q: "What areas do you serve?", a: "We serve families across the Dallas–Fort Worth metroplex including Dallas, Highland Park, Southlake, Frisco, Plano, Fort Worth and Colleyville." },
  { q: "How much does care cost?", a: "Sitter pay is $20/hr, plus $1/hr per additional child. Memberships start at $39/mo (Family Starter) and $59/mo (Family Pro). Pricing shown is for reference; our team confirms details with you." },
  { q: "How far in advance should I book?", a: "We recommend booking as early as possible, especially for weekends and events. We also do our best to accommodate last-minute and after-hours requests — call us at 972-476-0500." },
  { q: "Do you offer nanny or long-term placements?", a: "Yes — long-term nanny placements are handled through our sister service. We'll route you to the right team." },
  { q: "Are your caregivers CPR certified?", a: "Yes. 100% of our caregivers hold current pediatric CPR and First Aid certification." },
];

export const HOW_IT_WORKS = [
  { n: 1, title: "Tell us what you need", desc: "Choose your service, dates, number of children and location in a quick request." },
  { n: 2, title: "We match a screened sitter", desc: "Our team hand-selects an 11-step screened, CPR-certified caregiver for your family." },
  { n: 3, title: "We confirm the details", desc: "You'll hear from Jess, Jade or Shannon to confirm timing, your sitter and any special notes." },
  { n: 4, title: "Enjoy trusted care", desc: "Your caregiver arrives prepared. You relax knowing your children are in the best hands." },
];

export const SERVICE_NAMES = SERVICES.map((s) => s.name);
export const CITY_NAMES = CITIES.map((c) => c.name);
